export default "__VITE_ASSET__DijkteFm__"